import { GetSessionEngagementTotals } from '@/connection/engagement/get-session-engagement-totals';
import { ProjectStateReducerCreator } from '../types';

const fetchSessionEngagementTotalsReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async ({ sessionUuid }: { sessionUuid: string }) => {
      return GetSessionEngagementTotals(sessionUuid);
    },
    {
      fulfilled: (state, action) => {
        state.sessionEngagementTotals = action.payload;
      },
      pending: (state) => {
        state.loadingSessionEngagementTotals = true;
      },
      rejected: (state, action) => {
        console.error(action.error);
        state.sessionEngagementTotals = [];
      },
      settled: (state) => {
        state.loadingSessionEngagementTotals = false;
      },
    }
  );
};

export default fetchSessionEngagementTotalsReducer;
